import { Helpers } from '../../helpers';
import { IWellScreenType } from '../../interfaces/iwell-screen-type';
import { WaterWell } from '../water-well';

export class WellScreenTypeBase {
  WellScreenTypeId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  WaterWells_WellScreenType?: Array<WaterWell> | null;

  constructor(item?: IWellScreenType) {
    if (item) {
      this.WellScreenTypeId = item.WellScreenTypeId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.WaterWells_WellScreenType = Helpers.createClassArray(WaterWell, item.WaterWells_WellScreenType);

    }
  }
}